import { ProductTier } from '@sparemin/api-sdk';
import BasicPlan from '../Plan/BasicPlan/BasicPlan';
import FreePlan from '../Plan/FreePlan/FreePlan';
import ProGrowPlan from '../Plan/ProGrowPlan';
import ProPlan from '../Plan/ProPlan';
import UnlimitedPlan from '../Plan/UnlimitedPlan';
import PlanSelector, { PlanSelectorProps } from './PlanSelector';
import PlanSelectorPlanList, {
  PlanSelectorPlanListProps,
} from './PlanSelectorPlanList';
import withPlanSelector, {
  InjectedWithPlanSelectorProps,
} from './withPlanSelector';

const PlanSelectorBasicPlan = withPlanSelector(
  ProductTier.BASIC,
  'Basic',
)(BasicPlan);
const PlanSelectorFreePlan = withPlanSelector(ProductTier.FREE)(FreePlan);
const PlanSelectorProPlan = withPlanSelector(ProductTier.PRO, 'Pro')(ProPlan);
const PlanSelectorProGrowPlan = withPlanSelector(
  ProductTier.PRO,
  'Pro+Grow',
)(ProGrowPlan);
const PlanSelectorUnlimitedPlan = withPlanSelector(
  ProductTier.UNLIMITED,
  'Unlimited',
)(UnlimitedPlan);

interface PlanSelectorComponents {
  BasicPlan: typeof PlanSelectorBasicPlan;
  FreePlan: typeof FreePlan;
  PlanList: typeof PlanSelectorPlanList;
  ProPlan: typeof PlanSelectorProPlan;
  ProGrowPlan: typeof PlanSelectorProGrowPlan;
  UnlimitedPlan: typeof PlanSelectorUnlimitedPlan;
}

const PlanSelectorWithComponents: any = PlanSelector;
PlanSelectorWithComponents.PlanList = PlanSelectorPlanList;
PlanSelectorWithComponents.FreePlan = PlanSelectorFreePlan;
PlanSelectorWithComponents.BasicPlan = PlanSelectorBasicPlan;
PlanSelectorWithComponents.ProPlan = PlanSelectorProPlan;
PlanSelectorWithComponents.ProGrowPlan = PlanSelectorProGrowPlan;
PlanSelectorWithComponents.UnlimitedPlan = PlanSelectorUnlimitedPlan;

export default PlanSelectorWithComponents as typeof PlanSelector &
  PlanSelectorComponents;

export {
  InjectedWithPlanSelectorProps,
  PlanSelector,
  PlanSelectorPlanList,
  PlanSelectorPlanListProps,
  PlanSelectorProps,
};
